import { BrowserRouter, HashRouter } from "react-router-dom";
import AppRoutes from "./routes/router";

function App() {
  return (
    <HashRouter hashType="noslash">
      <AppRoutes></AppRoutes>
    </HashRouter>
    // <BrowserRouter>
    //   <AppRoutes></AppRoutes>
    // </BrowserRouter>
  );
}

export default App;
